import { Button, Divider, Result, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { showNotification } from 'services/NotificationService';
import {
  getOrderDetailById,
  OrderDetailResponse,
  printQuotation,
} from 'services/OrderServices';
import { LoadingOutlined, CheckCircleFilled } from '@ant-design/icons';
import {
  BuildingLibraryIcon,
  CreditCardIcon,
  BanknotesIcon,
  ArrowDownTrayIcon,
} from '@heroicons/react/24/outline'; // For outline icons
import { getListProduct, ListProduct } from 'services/MasterDataService';
import ShopFrontFooter from 'modules/shop-front/shop-front-component/ShopFrontFooter';
const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [orderId, setOrderId] = useState<string>('');
  const location = useLocation();
  const [showQuoteLoading, setQuoteLoading] = useState(false);
  const [paymentType, setPaymentType] = useState('bank');
  useEffect(() => {
    setOrderId(location.state.orderId);
    console.log(location.state.orderId);
  }, [location]);

  const handlePrintQuotation = () => {
    if (orderId) {
      setQuoteLoading(true);
      printQuotation(orderId)
        .then((data) => {
          // window.location.href = data.url;
          window.open(data.url, '_blank');
          setQuoteLoading(false);
        })
        .catch(() => {
          showNotification('warning', 'Print Quotation Failed');
          setQuoteLoading(false);
        });
    }
  };
  const [orderDetail, setOrderDetail] = useState<OrderDetailResponse>();

  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    if (orderId) {
      setLoading(true)
      getOrderDetailById(orderId)
        .then((data) => {
          // if(data.order_detail.status == 'FITTING COMPLETED') navigate('/server-error');
          // else setOrderDetail(data)
          setOrderDetail(data);
          setLoading(false)
        })
        .catch(() => {
          navigate('/server-error');
          setLoading(false)
        });
    }
  }, [orderId]);

  const getProductName = (productId: number) => {
    console.log(productId);
    const product = listProductsCascader.find((state) => {
      return state.product_id == productId;
    });
    return product ? product.name : '';
  };

  const [listProductsCascader, setListProductsCascader] = useState<
    ListProduct[]
  >([]);
  const fetchListProductCascader = async () => {
    try {
      const data = await getListProduct();
      const sorted_product_list_alphabetical = data.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      setListProductsCascader(sorted_product_list_alphabetical);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchListProductCascader();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Makes the scroll smooth
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  const getOrderType = (orderTypeString: string | undefined) => {
    if (orderTypeString == 'supply_install') {
      return 'On-Site Installation';
    } else {
      return 'In-Store Pickup';
    }
  };

  return (
    <div>
      <div className="flex flex-col items-center gap-3  max-w-screen-lg mx-5 md:mx-auto mb-40">
        <CheckCircleFilled style={{ fontSize: '70px', color: '#52c41a' }} />
        <span className="text-2xl mt-8  w-full text-center">
          Awesome! Your order has been submitted.
        </span>
        <span className="text-xl  mb-20 w-full text-center">
          Order reference: {orderDetail?.order_detail.order_refer_no}
        </span>
        
        <div className={`flex flex-col w-full mb-5`}>
          <span className="text-lg xl:text-2xl font-[450] mb-2">
            Order Summary
          </span>
          <Skeleton active loading={loading} paragraph={{ rows: 7 }} >
          <div className="w-full rounded-md flex flex-col bg-neutral-50 p-5">
            <div className="flex flex-col gap-1  ">
              {orderDetail?.items.map((item, index) => {
                return (
                  <div key={index}>
                    {item?.item_list?.length != 0 &&
                    item?.item_list != undefined ? (
                      <div className="text-neutral-500 text-sm xl:text-lg grid grid-cols-2 w-full gap-2">
                        <span>
                          x{item?.item_list?.length}&nbsp;&nbsp;
                          {getProductName(Number(item?.product_id))}
                        </span>

                        <span className="text-black text-right ">
                          $
                          {Number(item?.price)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                        </span>
                      </div>
                    ) : (
                      <span></span>
                    )}

                    {item?.product_id == '60' || item?.product_id == '30' ? (
                      <div className="text-neutral-500 text-sm xl:text-lg  grid grid-cols-2 w-full gap-2">
                        <span className="">
                          {getProductName(Number(item?.product_id))}:{' '}
                          {item?.main_info?.description}
                        </span>
                        <span className="text-black text-right ">
                          $
                          {Number(item?.price)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                        </span>
                      </div>
                    ) : (
                      <span></span>
                    )}
                    {item?.product_id == '28' ? (
                      <span className="text-neutral-500 text-sm xl:text-lg">
                        {getProductName(Number(item?.product_id))}:{' '}
                        {item?.main_info?.part_type_name}
                      </span>
                    ) : (
                      <span></span>
                    )}
                  </div>
                );
              })}
            </div>

            <div className=" mx-auto w-full">
              <Divider></Divider>
            </div>

            <div className="text-neutral-500 text-sm xl:text-lg grid grid-cols-1 w-full gap-2">
              Delivery: {getOrderType(orderDetail?.order_detail.order_type)}
            </div>

            <div className=" mx-auto w-full">
              <Divider></Divider>
            </div>

            <div className="grid grid-cols-2 w-full gap-2 text-neutral-500 ">
              <div className="text-sm xl:text-lg">Subtotal:</div>
              <span className="text-sm xl:text-lg text-black text-right ">
                $
                {orderDetail?.order_detail.price
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
              </span>
            </div>

            {
              <div className="grid grid-cols-2 w-full gap-2 text-neutral-500">
                <div className="text-sm xl:text-lg">
                  GST&nbsp;(
                  {orderDetail?.order_detail.order_gst
                    ? orderDetail?.order_detail.order_gst
                    : 0}
                  %):
                </div>
                <span className="text-sm xl:text-lg text-black text-right">
                  $
                  {(
                    (orderDetail?.order_detail.price
                      ? orderDetail?.order_detail.price
                      : 0) *
                    ((orderDetail?.order_detail.order_gst
                      ? orderDetail?.order_detail.order_gst
                      : 0) /
                      100)
                  )
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </span>
              </div>
            }

            <div className=" mx-auto w-full">
              <Divider></Divider>
            </div>

            {
              <div className={` grid grid-cols-2  mb-2  gap-2`}>
                <span className="font-[450] text-lg xl:text-2xl ">Total:</span>
                <span className="text-lg xl:text-2xl  text-black text-right font-[450]">
                  $
                  {orderDetail?.order_detail.total_price
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </span>
              </div>
            }
          </div>
          </Skeleton>
          
        </div>
        <div className={`flex flex-col w-full mb-5`}>
          <span className="text-lg xl:text-2xl font-[450] mb-2">
            {"What's next?"}
          </span>
          <div className="flex flex-row  p-5 rounded-md bg-neutral-50 ">
            <div className="flex flex-col">
              <p>
                To proceed, please make a 50% deposit of{' '}
                <strong>
                  $
                  {(orderDetail?.order_detail.total_price
                    ? orderDetail?.order_detail.total_price / 2
                    : 0
                  )
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </strong>{' '}
                via bank transfer or cash.
              </p>
              <p>
                Our cut-to-measure products cannot be altered once your order is
                confirmed, and additional fees may apply for any changes.
              </p>
              <p>
                Please note that cancellations will result in the forfeiture of
                your deposit.
              </p>
              <p>
                Please arrange to pay the remaining 50% of the balance directly
                to us on the day of installation.
              </p>
            </div>
          </div>
        </div>

        <div className={`flex flex-col w-full `}>
          <span className="text-lg xl:text-2xl font-[450] mb-2">
            Payment method
          </span>
          <div className="flex flex-col gap-3 ">
            <div className="w-full flex flex-row gap-3">
              <div
                onClick={() => {
                  setPaymentType('cash');
                }}
                className={`${
                  paymentType == 'cash'
                    ? 'border-2 border-black'
                    : 'border border-neutral-300'
                } w-1/3 h-[7rem] rounded-md  border-solid  flex flex-col p-5 gap-2 pt-5 transition-all duration-300 ease-in-out hover:-translate-y-1`}
              >
                <BanknotesIcon className="h-9 w-9 mr-auto"></BanknotesIcon>
                <span className="text-sm md:text-lg">Cash</span>
              </div>
              <div
                onClick={() => {
                  setPaymentType('bank');
                }}
                className={`${
                  paymentType == 'bank'
                    ? 'border-2 border-black'
                    : 'border border-neutral-300'
                } w-1/3 h-[7rem] rounded-md  border-solid  flex flex-col p-5 gap-2 pt-5 transition-all duration-300 ease-in-out hover:-translate-y-1`}
              >
                <BuildingLibraryIcon className="h-9 w-9 mr-auto"></BuildingLibraryIcon>
                <span className="text-sm md:text-lg"> Bank Transfer</span>
              </div>
              <div
                onClick={() => {
                  setPaymentType('card');
                }}
                className={`${
                  paymentType == 'card'
                    ? 'border-2 border-black'
                    : 'border border-neutral-300'
                } w-1/3 h-[7rem] rounded-md  border-solid  flex flex-col p-5 gap-2 pt-5 transition-all duration-300 ease-in-out hover:-translate-y-1`}
              >
                <CreditCardIcon className="h-9 w-9 mr-auto"></CreditCardIcon>
                <span className="text-sm md:text-lg">Card Payment</span>
              </div>
            </div>

            {paymentType == 'cash' && (
              <div className="flex flex-row p-5 rounded-md bg-neutral-50">
                <div className="flex flex-col">
                  <h2 className="text-lg font-bold">Cash Payment</h2>
                  <p className="mt-2">
                    To pay for this order with cash, contact{' '}
                    <strong>0404 431 431</strong> to arrange the cash payment.
                  </p>
                  <p className="mt-2">
                    Please provide your{' '}
                    <strong>
                      order reference (
                      {orderDetail?.order_detail.order_refer_no})
                    </strong>{' '}
                    when contacting us.
                  </p>
                </div>
              </div>
            )}
            {paymentType == 'bank' && (
              <div className="flex flex-row  p-5 rounded-md bg-neutral-50">
                <div className="flex flex-col">
                  <h1 className="text-lg font-bold">BSB Payment</h1>
                  <p className="mt-2">
                    Pay us via BSB using the following information:
                  </p>
                  <p className="mt-2">
                    <strong>Account Name:</strong> ALL IN 1<br />
                    <strong>BSB:</strong> 082 356
                    <br />
                    <strong>Account No:</strong> 157 133 944
                  </p>
                  <p className="mt-2">
                    <strong>
                      Please include your order reference (
                      {orderDetail?.order_detail.order_refer_no}) as a reference
                      during your bank transfer payment
                    </strong>
                    . Once the payment is made, contact{' '}
                    <strong>0404 431 431</strong> to notify us of the
                    transaction.
                  </p>
                </div>
              </div>
            )}
            {paymentType == 'card' && (
              <div className="flex flex-row  p-5 rounded-md bg-neutral-50">
                <div className="flex flex-col">
                  <h2 className="text-lg font-bold">Card Payment</h2>
                  <p className="mt-2">
                    Coming soon! In the meantime, please use one of the other
                    two payment methods.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-row-reverse w-full gap-3 mt-10">
          <button
            className="transform text-black bg-neutral-100 text-xl rounded-md  hover:text-black hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none mt-3"
            onClick={() => {
              navigate(`/order`);
            }}
          >
            <span className=" p-1">My Order History</span>
          </button>
          <button
            className="flex flex-row items-center transform text-white bg-black text-lg rounded-md  hover:text-black hover:bg-neutral-200 transition-transform duration-300 w-fit p-2 px-3 hover:-translate-y-1 border-none mt-3"
            onClick={() => {
              handlePrintQuotation();
            }}
          >
            <LoadingOutlined
              className={`${showQuoteLoading ? '' : 'hidden'} h-5 w-5 mr-1`}
            ></LoadingOutlined>
            <ArrowDownTrayIcon
              className={`${!showQuoteLoading ? '' : 'hidden'} h-5 w-5 mr-1`}
            >
              {' '}
            </ArrowDownTrayIcon>
            <span className="p-1 ">Download Quote</span>
          </button>
        </div>
      </div>
      <ShopFrontFooter></ShopFrontFooter>
    </div>
  );
};

export default OrderSuccess;
